export default __webpack_public_path__ + "static/media/leaves.57f11850.jpg";